import _ from 'lodash'
import {
  SAVED_SEARCH_ADDED,
  SAVED_SEARCH_LOOKUP,
  SAVED_SEARCH_OPEN_MODAL,
  SAVED_SEARCH_CLOSE_MODAL,
} from '../constants/actionTypes'

const initialState = {
  savedSearchName: '',
  isSearchSaved: false,
  isModalOpen: false,
  mostRecentSavedSearchId: null,
}

const reducer = (state = initialState, action) => {
  const newState = _.cloneDeep(state)
  switch (action.type) {
    case SAVED_SEARCH_ADDED:
      newState.authType = false
      newState.mostRecentSavedSearchId = action.value
      return newState
    case SAVED_SEARCH_CLOSE_MODAL:
      newState.isModalOpen = false
      newState.authType = false
      newState.mostRecentSavedSearchId = null
      return newState

    case SAVED_SEARCH_OPEN_MODAL:
      newState.isModalOpen = true
      newState.authType = action.authType
      return newState

    case SAVED_SEARCH_LOOKUP:
      return Object.assign({}, state, action.value)

    default:
      return state
  }
}

export default reducer
export { initialState }
